import { Api_routes, server_url } from '../config/API_Routes';
import { getRequest, patchRequest } from '../config/axios-config';

const getDashboardTutorialStatus = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.dashboardTutorial
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateDashboardTutorialStatus = async (tutorialName) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.dashboardTutorial + '/' + tutorialName
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export { getDashboardTutorialStatus, updateDashboardTutorialStatus };
